import axios from "axios";
import { BASE_API_URL } from "../../api";
import {
  AddAvailabilityDTO,
  VerifyDoctorDTO,
  AddDoctorPermissionsDTO,
  AddFeeDTO,
  AddServiceDTO,
  DeleteAvailabilityDTO,
  DeleteServiceDTO,
  DoctorRegisterDTO,
  DoctorValidateDTO,
  GetAvailabilityDTO,
  GetDoctorFeeDTO,
  GetDoctorPermissionsDTO,
  GetDoctorScheduleDTO,
  RegisterVerifyOTPDTO,
  GetUnAvailabilityDTO,
  AddUnAvailabilityDTO,
  DeleteUnAvailabilityDTO,
  ActivatDoctorDTO,
  GetPaymentDTO,
  GetDrPdfDTO,
  GetClinicPdfDTO,
  OfflineDoctorDTO,
  VerifyOflineDoctorDTO,
  GetPaymentAttachmentDTO,
  AddAvailabilityTimeSlotDTO,
} from "../../dtos/doctor";
function removeSpacesFromUrl(url: string): string {
  const urlComponents = url.split("/");
  for (let i = 0; i < urlComponents.length; i++) {
    urlComponents[i] = urlComponents[i].replace(/\s/g, "");
  }
  return urlComponents.join("/");
}
axios.defaults.withCredentials = true;

const validateDoctor = async (dto: DoctorValidateDTO) => {
  const { data } = await axios.post( "/api/doctor/validate", dto);
  return data;
};
const getSpecialities = async () => {
  const url =  "/api/speciality/names";
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};

const registerDoctor = async (doctor: DoctorRegisterDTO) => {
  const { data } = await axios.post(
     "/api/admin/doctor/add",
    doctor
  );
  return data;
};
const addAvailability = async (doctor: AddAvailabilityDTO) => {
  const { data } = await axios.post(
     "/api/admin/doctor/availability/add",
    doctor
  );
  return data;
};
const getAvailability = async (doctor: GetAvailabilityDTO) => {
  const url =
    
    `/api/admin/doctor/availability/get?clinic_id=${doctor.clinic_id}&dr_id=${doctor.doctor_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const deleteAvailability = async (dto: DeleteAvailabilityDTO) => {
  const { data } = await axios.delete(
    
      `/api/admin/doctor/availability/delete?clinic_id=${dto.clinic_id}&doctor_id=${dto.doctor_id}&availability_id=${dto.availabilityId}`
  );
  return data;
};
const addFee = async (dto: AddFeeDTO) => {
  const { data } = await axios.post(
     "/api/admin/doctor/fee/add",
    dto
  );
  return data;
};

const addService = async (dto: AddServiceDTO) => {
  const { data } = await axios.post( "/api/services/add", dto);
  return data;
};

const deleteService = async (dto: DeleteServiceDTO) => {
  const { data } = await axios.delete(
    
      `/api/services/delete?clinic_id=${dto.clinic_id}&services_id_to_del=${dto.services_id_to_del}&doctor_id=${dto.doctor_id}`
  );
  return data;
};
const getDoctorSchedule = async (dto: GetDoctorScheduleDTO) => {
  const url = `/api/doctor/schedule?clinic_id=${dto.clinic_id}&dr_id=${dto.dr_id}&date=${dto.date}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getDoctorFee = async (dto: GetDoctorFeeDTO) => {
  const url =
    
    `/api/doctor/fee/get?clinic_id=${dto.clinic_id}&doctor_id=${dto.doctor_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const registerVerifyOtp = async (dto: RegisterVerifyOTPDTO) => {
  const { data } = await axios.post(
     `/api/doctor/verify-otp`,
    dto
  );
  return data;
};
const getDoctorPermissions = async (dto: GetDoctorPermissionsDTO) => {
  const url =
    
    `/api/clinic/doc-permissions/view?clinic_id=${dto.clinic_id}&dr_id=${dto.dr_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const addDoctorPermissions = async (dto: AddDoctorPermissionsDTO) => {
  const { data } = await axios.post(
     `/api/clinic/doc-permissions/add`,
    dto
  );
  return data;
};

const verifyDoctor = async (dto: VerifyDoctorDTO) => {
  const { data } = await axios.post(
     `/api/admin/doctor/verify`,
    dto
  );
  return data;
};
const oflineDoctor = async (dto: VerifyOflineDoctorDTO) => {
  const { data } = await axios.post(
     `/api/admin/doctor/offline-status/change`,
    dto
  );
  return data;
};

const offlineDocStatus = async (dto: OfflineDoctorDTO) => {
  const url =
     `/api/admin/doctor/all?offline_status=${dto.offline_status}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const activeDoctor = async (dto: ActivatDoctorDTO) => {
  const { data } = await axios.post(
     `/api/admin/doctor/activation`,
    dto
  );
  return data;
};

const addDocUnAvailability = async (doctor: AddUnAvailabilityDTO) => {
  const { data } = await axios.post(
     "/api/admin/doctor/unavailability/add",
    doctor
  );
  return data;
};
const geDoctUnAvailability = async (doctor: GetUnAvailabilityDTO) => {
  const url =
    
    `/api/admin/doctor/unavailability/get?clinic_id=${doctor.clinic_id}&doctor_id=${doctor.doctor_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const deleteDocUnAvailability = async (dto: DeleteUnAvailabilityDTO) => {
  const { data } = await axios.delete(
    
      `/api/admin/doctor/unavailability/delete?clinic_id=${dto.clinic_id}&unavailability_id=${dto.unavailability_id}&doctor_id=${dto.doctor_id}`
  );
  return data;
};
const getDocPament = async (doctor: GetPaymentDTO) => {
  const url =
    
    `/api/admin/doctor/payments?month=${doctor.month}&year=${doctor.year}&due_payments_status=${doctor.due_payments_status}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getdrPaymentAttachments = async (attachment: GetPaymentAttachmentDTO) => {
  const url =
    
    `/api/admin/doctor/payments/attachment/get?month=${attachment.month}&year=${attachment.year}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);

  return data;
};
const getClicicPaymentAttachments = async (
  attachment: GetPaymentAttachmentDTO
) => {
  const url =
    
    `/api/admin/doctor/payments/attachment/get?month=${attachment.month}&year=${attachment.year}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getclinicPament = async (doctor: GetPaymentDTO) => {
  const url =
    
    `/api/admin/clinic/payments?month=${doctor.month}&year=${doctor.year}&due_payments_status=${doctor.due_payments_status}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getdrPdf = async (doctor: GetDrPdfDTO) => {
  const url =
    
    `/api/admin/doctor/settlement/pdf?month=${doctor.month}&year=${doctor.year}&clinic_id=${doctor.clinic_id}&dr_id=${doctor.dr_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getClinicPdf = async (doctor: GetClinicPdfDTO) => {
  const url =
    
    `/api/admin/clinic/settlement/pdf?month=${doctor.month}&year=${doctor.year}&clinic_id=${doctor.clinic_id}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const addAvailabilityTimeSlot = async (doctor: AddAvailabilityTimeSlotDTO) => {
  const { data } = await axios.post(
     "/api/admin/doctor/appointment/duration/set",
    doctor
  );
  return data;
};
const doctorService = {
  getDocPament,
  getdrPdf,
  getClinicPdf,
  getclinicPament,
  validateDoctor,
  getSpecialities,
  registerDoctor,
  addAvailability,
  getAvailability,
  addFee,
  deleteAvailability,
  addService,
  deleteService,
  getDoctorSchedule,
  getDoctorFee,
  registerVerifyOtp,
  getDoctorPermissions,
  addDoctorPermissions,
  verifyDoctor,
  deleteDocUnAvailability,
  geDoctUnAvailability,
  addDocUnAvailability,
  activeDoctor,
  oflineDoctor,
  offlineDocStatus,
  getdrPaymentAttachments,
  getClicicPaymentAttachments,
  addAvailabilityTimeSlot,
};

export default doctorService;
